import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { Router } from '@angular/router';
import { RouteTrackerService } from '@mpt-fo/common/core/services/route-tracker.service';
import { MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
	buttonName = 'Return to login';
	readonly LOGIN_USER = 'Go recent page';
	previousRoute = '/login';
	isMobileUser: boolean;

	constructor(
		private localStorage: LocalStorageService,
		private router: Router,
		private routeTracker: RouteTrackerService,
		private mobileService: MobileWebViewService
	) {}

	ngOnInit(): void {
		this.isMobileUser = this.mobileService.isMobileWebViewUser();
		this.previousRoute = this.routeTracker.getRoutes()?.previousRoute;
		this.buttonName = this.localStorage.hasAccessToken() ? this.LOGIN_USER : this.buttonName;
	}

	navigate() {
		if (this.buttonName === this.LOGIN_USER) {
			this.router.navigateByUrl(`${this.previousRoute}`);
		} else {
			this.router.navigateByUrl(`${this.previousRoute}`);
		}
	}
}
